var $ = global.jQuery = global.$;

require('../third-party/jquery.chained');
require('../third-party/fancySelect');

var _Base = require('./_Base');

 /**
  * @extends Base widget
  * @class
  */
var BookingFormFilter_PTS = _Base.extend(
  /** @lends _Base.prototype */
  {
    init: function () {

      $("#SpecialismCategory").chained("#CourseSpecialism");
      $("#Course").chained("#SpecialismCategory");

      //var mySelect = $('.BookingCourseFilterList');
      //mySelect.fancySelect().on('change.fs', function() {
      //    $(this).trigger('change.$');
      //}); // trigger the DOM's change event when changing FancySelect



    }
});
module.exports = BookingFormFilter_PTS;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/BookingFormFilter_PTS.js
// module id = 335
// module chunks = 1